import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useAppContext } from "@/lib/onboardingContext";

interface BeginnerTooltipProps {
  tip: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * Shows a help icon with tooltip ONLY when beginner mode is ON.
 * Renders nothing in advanced mode.
 */
export default function BeginnerTooltip({ tip, children, className = "" }: BeginnerTooltipProps) {
  const { beginnerMode } = useAppContext();
  if (!beginnerMode) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {children || (
          <HelpCircle className={`w-3.5 h-3.5 text-muted-foreground/60 hover:text-primary cursor-help transition-colors shrink-0 ${className}`} />
        )}
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-xs leading-relaxed">
        {tip}
      </TooltipContent>
    </Tooltip>
  );
}

/**
 * Helper: returns beginner-friendly or professional text based on mode.
 */
export function useBeginnerText() {
  const { beginnerMode } = useAppContext();
  return (beginner: string, advanced: string) => beginnerMode ? beginner : advanced;
}
